import FlockList from './FlockList';

export default FlockList;
